module.exports = __webpack_public_path__ + "static/media/radio_normal_desktop.2dd15ab2.svg";